import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import { isQuizSaved } from '../states/quizState'
import {QuizChoice} from './QuizChoice'

export const QuizResponse = ({ meta, onRespond, events, defaultResponse}: QuizResponseType): JSX.Element => {
    const setIsSaved = useSetRecoilState(isQuizSaved)
    
    useEffect(() => {
        return () => {
            setIsSaved(false)
        }
    }, [])
    return(
    <>    
        <ul className="quizResponse">
            {
                Object.keys(events).map((responseKey: string, key: number) => {
                    return (
                        <li key={`quizChoice-${key}`} onClick={() => onRespond(responseKey)} className={defaultResponse == responseKey ? 'quizResponse-active' : ''}>
                            <QuizChoice key={key} responseKey={responseKey} imgId={responseKey} index={key + 1}/>
                        </li>
                    )
                })
            }
        </ul>
    </>
    )
}

type QuizResponseType = {
    defaultResponse?: string
    events: {[key: string]: any}
    meta: {[key: string]: any}
    onRespond: (val: string) => void
}

